exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".text-white{color:#fffdf8!important}.bg-white,.q-layout-drawer,.q-popover,.q-tab{background:#fff!important}.bg-info{background:#287baf!important}.bg-positive{background:#00d1d2!important}.q-table,.text-dark,body{color:#34303d!important}.q-input-target,.q-table-bottom,.q-table th{color:#524f5a!important}.q-chip{color:#34303d;background:#e1e0e2}.text-red{color:#db3624!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2e4afc43","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/layouts/basic.vue
// module id = /Qu2
// module chunks = 44